module.exports = __webpack_public_path__ + "img/add.bc263017.svg";